// src/ThreeJs/Global/UndoController.js
import {
  popUndoAction,
  canUndo,
  popRedoAction,
  canRedo,
  pushUndoAction,
  pushRedoAction,
  pushUndoActionFromRedo, // ⬅️ NEW: used only by redo
} from "./UndoManager";

/**
 * Called from keyboard handler / toolbar when user triggers an undo.
 * Runs the last stored undo closure if available.
 */
export function performGlobalUndo() {
  if (!canUndo()) return;

  const action = popUndoAction();
  try {
    action?.undo();
    // After an undo, the same action becomes redo-able
    if (action) {
      pushRedoAction(action);
    }
  } catch (err) {
    console.error("Global undo failed:", err);
  }
}

/**
 * Called from keyboard handler / toolbar when user triggers a redo.
 * Re-runs the last undone action if available.
 */
export function performGlobalRedo() {
  if (!canRedo()) return;

  const action = popRedoAction();
  try {
    if (typeof action?.redo === "function") {
      // Proper redo closure provided
      action.redo();
    } else if (typeof action?.undo === "function") {
      // Fallback: treat redo as re-running undo
      // Works for symmetric operations; for moves you should supply a real `redo`.
      action.undo();
    }

    // After redo, the action is again undoable
    if (action) {
      // ⬅️ IMPORTANT: don't clear redoStack when re-adding this
      pushUndoActionFromRedo(action);
    }
  } catch (err) {
    console.error("Global redo failed:", err);
  }
}
